import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class WhiteBoardIcon extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon fill="#F0F0F0" {...this.props}>
                <path
                    d={`M22.1,4.7c0.5,0,0.9-0.4,0.9-0.9v0c0-0.5-0.4-0.9-0.9-0.9H13c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.5-0.4-0.7
                        c-0.3-0.2-0.7-0.3-1-0.1C11.2,1.3,11,1.5,11,1.9c0,0.3,0,0.6,0,0.9H1.9C1.4,2.8,1,3.3,1,3.8v0c0,0.5,0.4,0.9,0.9,0.9h0.4
                        c0,3.7,0,7.4,0,11.1H1.9c-0.5,0-0.9,0.4-0.9,0.9v0c0,0.5,0.4,0.9,0.9,0.9h7.9c-1.1,1.3-2.2,2.5-3.4,3.8c-0.4,0.4-0.3,1,0.1,1.3
                        c0.4,0.3,1,0.3,1.4-0.1c0.8-0.9,1.5-1.7,2.3-2.6c0.3-0.3,0.5-0.6,0.8-0.9c0,0.1,0,0.1,0,0.2c0,0.9,0,1.8,0,2.7c0,0.5,0.4,1,1,1
                        c0.6,0,1-0.4,1-1c0-0.6,0-1.2,0-1.8c0-0.4,0-0.7,0-1.1c0.1,0.1,0.1,0.2,0.2,0.2c1,1.1,2,2.2,2.9,3.3c0.2,0.2,0.4,0.3,0.7,0.3
                        c0.4,0,0.7-0.1,0.9-0.5c0.2-0.4,0.1-0.7-0.1-1c-1.1-1.3-2.3-2.5-3.4-3.8h7.9c0.5,0,0.9-0.4,0.9-0.9v0c0-0.5-0.4-0.9-0.9-0.9h-0.4
                        c0-3.7,0-7.4,0-11.1H22.1z`}
                />
            </SvgIcon>
        );
    }
}
